import {
  ChangeDetectionStrategy,
  Component,
  NgZone,
} from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  standalone: true,
  selector: 'app-home-report',
  templateUrl: './home-report.component.html',
  styleUrls: ['./home-report.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeReportComponent {
  urlIframe: SafeUrl = `https://reporteador.syspotec.co/RenderApi/RenderizarReporteCors?UserNameCors=7182158&CodigoEmpresaCors=0&CodReporteMaestro=50&CokieCors=20190318173240_292_CokieCorsConsulta_uaf1wce3_k1z&StringJsonParameters={"Tarjetas":[{"CodTarjeta":0,"Parametros":{"prametro1":"0"}}]}&StringJsonHomologaConexion={"TarjetasHomologadas":[{"CodConnectionStrings":5,"CodConnectionStringsHomologado":1021,"UrlReporting":"/Inviare/MiProyectoxx","UrlReportingHomologado":"/InviareSyspotec/MiProyectoxx/"}]}&EventCommand=consultarreportedialog`;

  private messageListener: any;

  constructor(private ngZone: NgZone) {
    this.setupMessageListener();
  }
  
  private setupMessageListener() {
    this.messageListener = (event: MessageEvent) => {
      // Verificar el origen por seguridad
      if (event.origin !== 'https://reporteador.syspotec.co') return;

      this.ngZone.run(() => {
        //if (event.data.type === 'ANGULAR_MESSAGE') {
        if (event.data.type === 'message') {
        }
      });
    };

    window.addEventListener('message', this.messageListener);
  }
}
